import React, { useContext } from "react";
import type { FC } from "react";

import { Illustration } from "../../../Illustration";
import { VibeContext } from "../../Vibe";
import { ILLUSTRATION_SIZE_BY_VIBE_CONTEXT } from "../../constants/sizes";

import type { IllustrationProps } from "../../../Illustration";

const VIBE_ILLUSTRATION_TEST_ID = "vibe-illustration-test-id";

export const VibeIllustration: FC<IllustrationProps> = ({
    "data-tsid": tsid = VIBE_ILLUSTRATION_TEST_ID,
    ...otherProps
}) => {
    const { context } = useContext(VibeContext);

    const illustrationProps: IllustrationProps = (() => {
        if (context !== "custom") {
            return {
                ...otherProps,
                size: ILLUSTRATION_SIZE_BY_VIBE_CONTEXT[context],
            };
        }

        return otherProps;
    })();

    return <Illustration data-tsid={tsid} {...illustrationProps} />;
};

VibeIllustration.displayName = "Vibe.Illustration";

export default VibeIllustration;
